import { Environment } from "src/app/interfaces";

export const environment: Environment = {
  production: true,
  name: "staging",
  release: "202610.30.01-1086",
  apiUrl: "https://s.api.jericommerce.com",
  appUrl: "https://s.jeri.link",
};
